import { default as Tag } from 'antd/es/tag';

import { getColor } from '../utils/getColorOfHttpMethod';

import { CopyToClipboard } from './CopyToClipboard';
import { generateBaseApiUrl } from '../utils/generateBaseApiUrl';

export const EndpointPath = ({
  method,
  path
}: {
  method: string;
  path: string;
}) => {
  return (
    <pre className="relative overflow-auto rounded-md bg-inpay-dark-green-1000 p-2.5 text-white">
      <Tag bordered={false} className={getColor(method)}>
        <p className="text-bold text-white dark:text-white">{method}</p>
      </Tag>
      <span data-testid={`endpoint-path-${path}`}>
        {generateBaseApiUrl(path)}
      </span>
      <CopyToClipboard value={path} absolute />
    </pre>
  );
};
